module.exports = __webpack_public_path__ + "img/image-outline.c497ea21.svg";